import { EMPTY_OBJECT } from 'commons-ui';
import { SOCIAL_RESOURCES, URL } from '../../helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[SOCIAL_RESOURCES.memes]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: `${URL[SOCIAL_RESOURCES.memes]}/clone`,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[SOCIAL_RESOURCES.memes]}/create`
				});
			};
		default:
			return () => {
				return null;
			};
	}
};

export default {
	makeActionHandler
};
